<template>
	<div class="GoodList">
		<common-body aside="1">
			<div slot="commonMain" class="list_box">
				<el-row type="flex" align="middle" class="list_header">
					<div class="location_icon">
						<i class="el-icon-s-promotion"></i>
					</div>
					<el-row type="flex" align="middle" class="location_text">
						<div>当前位置：</div>
						<el-button @click="goBack" type="text">产品分类</el-button>
						<div class="location_xie">/</div>
						<div>产品列表</div>
					</el-row>
					<el-row type="flex" align="middle" class="search_box">
						<el-input class="search_input" placeholder="搜索关键词" v-model="search"></el-input>
						<el-row type="flex" align="middle" justify="center" class="search_img">
							<img src="../assets/img/search.png" />
						</el-row>
						<div  @click="searchList" class="search_btn"></div>
					</el-row>
					<el-select @change="changeType" class="list_type" v-model="typeIndex" placeholder="请选择">
						<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="index">
						</el-option>
					</el-select>
				</el-row>
				<el-table @row-click="showDetail" :data="list" style="width: 100%" cell-class-name="good_text" header-cell-class-name="good_header">
					<el-table-column align="center" min-width="4%" label="序号" class-name="is-num">
						<template slot-scope="scope">
							<div>{{scope.$index+1}}</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="8%" label="图片">
						<template slot-scope="scope">
							<div class="good_img">
								<img :src="scope.row.image" />
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" min-width="20%" prop="name" label="产品名称">
					</el-table-column>
					<el-table-column align="center" min-width="16%" prop="model" label="产品型号">
					</el-table-column>
					<!-- <el-table-column align="center" min-width="12%" prop="specs" label="规格">
						<template slot-scope="scope">
							<div>{{scope.row.specs&&scope.row.specs!=""?scope.row.specs:'无'}}</div>
						</template>
					</el-table-column> -->
					<el-table-column align="center" min-width="8%" prop="unit" label="单位">
					</el-table-column>
					<el-table-column align="center" min-width="12%" prop="price" label="售价(元)" class-name="is-amount">
					</el-table-column>
					<el-table-column align="center" min-width="22%" prop="summary" label="概述">
						<template slot-scope="scope">
							<div>{{scope.row.summary&&scope.row.summary!=""?scope.row.summary:'无'}}</div>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination class="good_page" :hide-on-single-page="pageSingle" @current-change="changePage" :page-size="limit" prev-text="上一页" next-text="下一页"
				 background layout="prev, pager, next" :total="listTotal">
				</el-pagination>
			</div>
		</common-body>
	</div>
</template>

<script>
	export default {
		name: 'GoodList',
		data() {
			return {
				search: '',
				pid: '',
				types: [{id: '',name: '全部分类'}],
				typeIndex: 0,
				page: 1,
				pageSingle: !1,
				limit: 5,
				listTotal: 0,
				list: [],
				ruleList: JSON.parse(localStorage.getItem('ruleList'))
			}
		},
		// beforeRouteEnter(to, from, next) {
		// 	if (from.name == 'GoodDetail') {
		// 		next(vm=>{
		// 			vm.getList()
		// 		})
		// 	}else{
		// 		next();
		// 	}
		// },
		beforeRouteLeave(to,from,next) {
			from.meta.keepAlive = !1
			next()
		},
		created() {
			this.reload();
		},
		methods: {
			reload() {
				let that = this
				that.pid = that.$route.query.id,that.getType()
			},
			getType(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getCategory',{pid: that.pid}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.types = that.types.concat(res.data),that.getList()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			getList(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getGoodsList',{page: that.page,limit: that.limit,search: that.search,pid: that.pid,category_id: that.types[that.typeIndex].id}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.list = res.data.list,that.listTotal = res.data.total
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			changeType(e) {
				let that = this
				that.typeIndex = e,that.page = 1,that.list = [],that.listTotal = 0,that.getList()
			},
			changePage(e) {
				let that = this
				that.page = e,that.getList()
			},
			searchList(e){
				let that = this
				that.getList()
			},
			showDetail(e) {
				let that = this
				that.$router.push(`/goodDetail?id=${e.id}`)
			},
			goBack(){
				this.$router.back()
			}
		}
	};
</script>

<style src='../assets/css/goodList.css'>
	/* px2rem能正常转换 */
</style>
